import React from 'react';
import PopupFotosEntregaProducao from '../components/PopupFotosEntregaProducao';
import AceiteFinalProjeto from '../components/AceiteFinalProjeto';

const formatBRL = (v) => {
  const n = Number(v || 0);
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export default function FormularioProducao({
  aberto,
  onFechar,
  form,
  setForm,
  statusProducao,
  responsaveisProducao,
  calculatedCosts,
  onSalvar,
  onBaixarPdf,
  pdfAprovacaoExistente,
  temFotosAntigas = false, // fotos anexadas no projeto antes de as fotos irem para cada entrega
  producaoId,
  onGestaoFinanceira,
  onMateriaPrima
}) {
  const finalizado = /conclu|finaliz/i.test(form.statusOriginal || '');
  // Pop-up das fotos da entrega da produção
  const [fotosEntregaAberto, setFotosEntregaAberto] = React.useState(false);
  if (!aberto) return null;

  return (
    <div className="modal-overlay" onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 95000 }}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ width: '92%', maxWidth: 900, background: '#fff', borderRadius: 12, padding: 20, maxHeight: '85vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h3 style={{ margin: 0, color: 'rgb(235, 133, 0)' }}>Editar Projeto</h3>
          <button onClick={onFechar} aria-label="Fechar" title="Fechar" style={{ backgroundColor: 'rgb(235, 133, 0)', color: '#fff', border: 'none', borderRadius: '50%', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, cursor: 'pointer', boxShadow: '0 2px 6px rgba(0,0,0,0.15)' }}>×</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          {/* ID */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>ID Projeto</label>
            <input type="text" readOnly value={form.producaoId || ''} style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd', background: '#f5f5f5' }} />
          </div>
          {/* Título */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Título</label>
            <input type="text" value={form.titulo || ''} onChange={(e) => setForm({ ...form, titulo: e.target.value })} style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd' }} />
          </div>

          {/* Status */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Status</label>
            <select value={form.status || ''} onChange={(e) => {
              const statusNome = e.target.value;
              const statusObj = statusProducao.find(s => (s.nome || s.Nome) === statusNome);
              const statusId = statusObj?.id || statusObj?.Id || '';
              setForm({ ...form, status: statusNome, statusProducaoId: statusId });
            }} disabled={finalizado} title={finalizado ? 'Projeto finalizado pelo aceite do cliente' : 'O status Finalizado vem do aceite do cliente'} style={{
              padding: '10px', borderRadius: 6, border: '1px solid #ddd', cursor: finalizado ? 'not-allowed' : 'pointer', fontWeight: 700,
              // Igual ao Status de Custo: verde (pendente, finalizado...) e vermelho só no Cancelado
              backgroundColor: /cancel/i.test(form.status || '') ? '#fdecea' : '#e6f4ea',
              color: /cancel/i.test(form.status || '') ? '#d93025' : '#1e8e3e'
            }}>
              <option value="">Selecione...</option>
              {/* Finalizado não se escolhe: vem só do aceite do cliente */}
              {statusProducao
                .filter((status) => finalizado || !/conclu|finaliz/i.test(status.nome || status.Nome || ''))
                .map((status) => (
                  <option key={status.id || status.Id} value={status.nome || status.Nome}>{status.nome || status.Nome}</option>
                ))}
            </select>
          </div>

          {/* Status Custo */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Status de Custo</label>
            {/* Automático: Dentro do Orçamento → Em Risco (a partir de 85% do custo orçado) → Estourado (passou do custo orçado) */}
            <input
              type="text"
              readOnly
              value={form.statusCusto || 'Dentro do Orçamento'}
              title="Calculado automaticamente pelo custo acumulado em relação ao custo orçado"
              style={{
                padding: '10px', borderRadius: 6, border: '1px solid #ddd', cursor: 'not-allowed', fontWeight: 700,
                backgroundColor: /estour/i.test(form.statusCusto || '') ? '#fdecea' : /risco/i.test(form.statusCusto || '') ? '#fff8e1' : '#e6f4ea',
                color: /estour/i.test(form.statusCusto || '') ? '#d93025' : /risco/i.test(form.statusCusto || '') ? '#b26a00' : '#1e8e3e'
              }}
            />
          </div>

          {/* Previsto x real. As datas de entrega e de montagem ficam em cada entrega e tarefa de montagem */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Conclusão do Desenvolvimento (prevista)</label>
            <input type="date" value={form.dataConclusaoDesenvolvimentoPrevista || ''} onChange={(e) => setForm({ ...form, dataConclusaoDesenvolvimentoPrevista: e.target.value })} style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd' }} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Conclusão do Desenvolvimento (real)</label>
            <input type="date" value={form.dataConclusaoDesenvolvimentoReal || ''} onChange={(e) => setForm({ ...form, dataConclusaoDesenvolvimentoReal: e.target.value })} style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd' }} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Finalização do Projeto (prevista)</label>
            <input type="date" value={form.dataFinalizacaoPrevista || ''} onChange={(e) => setForm({ ...form, dataFinalizacaoPrevista: e.target.value })} style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd' }} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Finalização do Projeto (real)</label>
            <input type="date" readOnly value={form.dataFinalizacaoReal || ''} title="Preenchida automaticamente quando o cliente aprova" style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />
          </div>
          {form.garantiaAte && (
            <div style={{ display: 'flex', flexDirection: 'column', gridColumn: '1 / -1' }}>
              <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Garantia até</label>
              <input type="text" readOnly value={`${form.garantiaAte.split('-').reverse().join('/')} (${form.prazoGarantiaMeses} meses a partir da aprovação)`} style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />
            </div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Contrato ID</label>
            <input type="number" value={form.contratosId || ''} readOnly title="Gerado automaticamente; não pode ser alterado" style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Valor Contrato (R$)</label>
            <input type="text" value={formatBRL(form.valorContrato)} readOnly title="Calculado automaticamente" style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />
          </div>

          {/* Orçamento ID / Valor / Custo etc */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Orçamento ID</label>
            <input type="number" value={form.orcamentoId || ''} readOnly title="Gerado automaticamente; não pode ser alterado" style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Valor Orçamento (R$)</label>
            <input type="text" value={formatBRL(form.orcamentoValor)} readOnly title="Custo orçado + lucro − desconto (preço final do orçamento)" style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Custo Orçado (R$)</label>
            <input type="text" value={formatBRL(form.custoOrcado)} readOnly title="Custo previsto no orçamento (sem o lucro)" style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Custo Acumulado (R$)</label>
            <input type="text" value={formatBRL(form.custoAcumulado)} readOnly title="Custo real do projeto: horas reais × custo/hora dos responsáveis, matéria-prima usada e serviços terceiros (projeto e tarefas)" style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Cliente ID</label>
            <input type="number" value={form.clienteId || ''} readOnly title="O cliente do projeto não pode ser alterado" style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Oportunidade ID</label>
            <input type="number" value={form.oportunidadeId || ''} readOnly title="Gerado automaticamente; não pode ser alterado" style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />
          </div>

          {/* Entregas, montagens e link de aprovação do cliente (substitui o PDF anexado à mão) */}
          {producaoId && (
            <AceiteFinalProjeto producaoId={producaoId} onBaixarPdf={onBaixarPdf} pdfAprovacaoExistente={pdfAprovacaoExistente} />
          )}

          {/* Matéria-prima do projeto: abre a tela Matéria Prima já com o pop-up deste projeto */}
          <div style={{ padding: 12, backgroundColor: '#f9f9f9', borderRadius: 8, border: '1px solid #e0e0e0', gridColumn: '1 / -1', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <h4 style={{ margin: '0 0 6px 0', color: 'rgb(235, 133, 0)' }}>Matéria-Prima do Projeto</h4>
            <div style={{ fontSize: 13, color: '#666', marginBottom: 10 }}>
              Veja o que foi reservado no orçamento, o que já foi usado e o reservado restante deste projeto.
            </div>
            <button
              type="button"
              onClick={onMateriaPrima}
              style={{ padding: '8px 16px', backgroundColor: 'rgb(235, 133, 0)', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
            >
              📦 Ver matéria-prima deste projeto
            </button>
          </div>

          {/* Resumo de Lucro — Previsto vs Real */}
          {(() => {
            const c = calculatedCosts || {};
            const orcValorTotal = c.orcamentoValorTotal || Number(form.orcamentoValor || 0);
            const contrato = Number(form.valorContrato || 0);
            const custosPrev = (c.orcamentoLaborPrevisto || 0) + (c.orcamentoMateriaPrevista || 0) + (c.orcamentoServicosTerceiros || 0);
            const custosReal = Number(form.custoAcumulado ?? c.totalReal ?? 0) || 0;
            const lucroPrev = orcValorTotal - custosPrev;
            const lucroReal = contrato - custosReal;

            let porcentagem = 0;
            if (lucroPrev > 0) porcentagem = (lucroReal / lucroPrev) * 100;
            else if (lucroPrev === 0 && lucroReal > 0) porcentagem = 100;
            else porcentagem = lucroReal < 0 ? -100 : 0;

            const corPct = porcentagem >= 80 ? '#2e7d32' : porcentagem >= 60 ? '#9e9e9e' : '#c62828';

            const FIXED_BAR = 70;
            const maxVal = Math.max(Math.abs(lucroPrev), Math.abs(lucroReal), 1);
            const barPrev = lucroPrev > 0 ? (lucroPrev / maxVal) * FIXED_BAR : 4;
            const barReal = lucroReal > 0 ? (lucroReal / maxVal) * FIXED_BAR : 4;

            return (
              <div style={{ marginTop: 18, padding: 16, background: '#fff8e1', borderRadius: 8, border: '1px solid #ffecb3', gridColumn: '1 / -1' }}>
                <h4 style={{ margin: '0 0 14px 0', color: '#b26a00' }}>💰 Lucro Previsto vs Real</h4>

                {/* Gráfico de barras */}
                <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #e0e0e0', padding: 16 }}>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', gap: 32 }}>
                    {/* Barra Previsto */}
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: 12, fontWeight: 600, color: '#e53935', marginBottom: 6 }}>{formatBRL(lucroPrev)}</div>
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', height: FIXED_BAR * 2 + 10 }}>
                        <div style={{ width: 38, height: barPrev, background: '#e53935', borderRadius: '4px 4px 0 0', transition: 'height 0.4s ease' }} />
                      </div>
                      <div style={{ fontWeight: 700, fontSize: 12, marginTop: 6, color: '#333' }}>Previsto</div>
                    </div>

                    {/* Porcentagem central */}
                    <div style={{ textAlign: 'center', marginBottom: 26, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end' }}>
                      <div style={{ fontSize: 20, fontWeight: 800, color: corPct, lineHeight: 1 }}>
                        {lucroPrev > 0 ? `${porcentagem.toFixed(1)}%` : '—'}
                      </div>
                      <div style={{ fontSize: 10, color: '#999', marginTop: 3, fontWeight: 600 }}>Real / Prev</div>
                    </div>

                    {/* Barra Real */}
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: 12, fontWeight: 600, color: lucroReal >= 0 ? '#2e7d32' : '#c62828', marginBottom: 6 }}>{formatBRL(lucroReal)}</div>
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', height: FIXED_BAR * 2 + 10 }}>
                        <div style={{ width: 38, height: barReal, background: lucroReal >= 0 ? '#2e7d32' : '#c62828', borderRadius: '4px 4px 0 0', transition: 'height 0.4s ease' }} />
                      </div>
                      <div style={{ fontWeight: 700, fontSize: 12, marginTop: 6, color: '#333' }}>Real</div>
                    </div>
                  </div>

                  {/* Legenda */}
                  <div style={{ display: 'flex', justifyContent: 'center', gap: 20, marginTop: 12 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 11 }}>
                      <div style={{ width: 12, height: 12, background: '#e53935', borderRadius: 2 }} /><span style={{ color: '#666' }}>Lucro Previsto</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 11 }}>
                      <div style={{ width: 12, height: 12, background: '#2e7d32', borderRadius: 2 }} /><span style={{ color: '#666' }}>Lucro Real</span>
                    </div>
                  </div>
                </div>

                {/* Botão Gestão Financeira Completa */}
                <div style={{ textAlign: 'center', marginTop: 14 }}>
                  <button
                    onClick={onGestaoFinanceira}
                    style={{
                      padding: '10px 24px', background: '#e65100', color: '#fff',
                      border: 'none', borderRadius: 6, cursor: 'pointer',
                      fontWeight: 700, fontSize: 14, letterSpacing: 0.3
                    }}
                  >
                    Gestão Financeira Completa
                  </button>
                </div>
              </div>
            );
          })()}

          {/* Fotos anexadas no projeto antes de cada entrega ter as suas (só para consulta do que já existia) */}
          {producaoId && temFotosAntigas && (
            <div style={{ padding: 12, backgroundColor: '#f9f9f9', borderRadius: 8, border: '1px solid #e0e0e0', gridColumn: '1 / -1', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
              <h4 style={{ margin: '0 0 6px 0', color: 'rgb(235, 133, 0)' }}>Fotos Antigas da Entrega</h4>
              <div style={{ fontSize: 13, color: '#666', marginBottom: 10 }}>
                Agora as fotos ficam em cada entrega (menu Entregas). Aqui estão as que foram anexadas antes.
              </div>
              <button
                type="button"
                onClick={() => setFotosEntregaAberto(true)}
                style={{ padding: '8px 16px', backgroundColor: 'rgb(235, 133, 0)', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
              >
                📷 Ver fotos antigas
              </button>
            </div>
          )}
        </div>
        {fotosEntregaAberto && (
          <PopupFotosEntregaProducao producaoId={producaoId} onFechar={() => setFotosEntregaAberto(false)} />
        )}

        {/* Botões */}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginTop: 20 }}>
          <button onClick={onSalvar} style={{ padding: '12px 30px', backgroundColor: 'rgb(235, 133, 0)', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}>Salvar</button>
          <button onClick={onFechar} style={{ padding: '12px 30px', backgroundColor: '#f44336', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}
